<div class="row">
  <div class="col-md-12">
      <yt-koz-dokument-stavka-inline-update #baseInlineUpdate></yt-koz-dokument-stavka-inline-update>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
      <yt-fw-default-detail-list-inline 
        [Model]="modelData.MainList.DetailList[0]" 
        [ParentPropertyName]="_parentPropertyName" 
        [ParentPropertyValue]="_parentPropertyValue" 
        [Disabled]="!_parentPropertyValue || _parentPropertyValue <= 0">
      </yt-fw-default-detail-list-inline>
  </div>
</div>